import { Flex } from '@mantine/core';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';

interface Props {
	title: string;
	value?: string;
}

export const InfoBoxRow = ({ title, value }: Props) => {
	return (
		<Flex direction="column" gap="0.25rem">
			<Text variant="p-sm" bold elipsis>
				{title}
			</Text>
			{value ? (
				<Text variant="sans/25/200" disableVariantMapping elipsis>
					{value}
				</Text>
			) : null}
		</Flex>
	);
};
